export default __webpack_public_path__ + "images/a9d24fccf4409c88c22a89fc8046ce1e-human_rights_small.webp";